import GenericDialog from "./generic";
import { deviceDataQualitySet } from "api/device";
import { StatusDropdown } from "models/dropdowns/status";
import { deviceVerifiedIcon } from "providers/icons";
import { notifySimple } from "providers/toast";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLoading } from "store/appSlice";
import Radio from "widgets/shared/inputs/radio";

const DataQualityDialog = (props: {
  isOpen: boolean;
  device: any;
  onClose: () => void;
  onSuccess: () => void;
}) => {
  const { isOpen, device, onClose, onSuccess } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [selectedRole, setSelectedRole] = useState("");

  // Function for linking an user
  const doDqEdit = async () => {
    dispatch(setLoading(true));

    const { status } = await deviceDataQualitySet(
      device.snr,
      selectedRole
    );
    dispatch(setLoading(false));
    if (status === 200) {
      onSuccess();
      notifySimple(t("notification.data.quality.success"), "success");
    } else {
      notifySimple(t("notification.data.quality.error"), "error");
    }
  };

  useEffect(() => {
    if (device && device?.dataQuality) {
      setSelectedRole(device.dataQuality);
    }
  }, [device]);

  return (
    <GenericDialog
      isOpen={isOpen}
      title={t("dialog.data.quality.title")}
      onOk={doDqEdit}
      onClose={onClose}
      onExit={onClose}
    >
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
        {StatusDropdown &&
          StatusDropdown.map((item, index) => {
            const { verifiedIcon } = deviceVerifiedIcon(item.label);
            return (
              <div
                className="flex items-center text-sm"
                key={`data-quality-${index}`}
              >
                <Radio
                  labelKey={item.label}
                  color="secondary"
                  checked={selectedRole === item.value}
                  onChange={() => {
                    setSelectedRole(item.value);
                  }}
                />
                <div className="flex items-center text-secondary ml-2">
                  {verifiedIcon}
                </div>
              </div>
            );
          })}
      </div>
    </GenericDialog>
  );
};

export default DataQualityDialog;
